/** Nav entries shown under points in GamanzaPlayerDrawer. Extend as more widgets land. */
export const GAMANZA_DRAWER_LINKS = [
  {
    id: "reward-shop",
    label: "Tienda de Recompensas",
    path: "/reward-shop",
  },
  {
    id: "my-boosters",
    label: "Mis Potenciadores",
    path: "/my-boosters",
  },
  {
    id: "missions",
    label: "Misiones",
    path: "/missions",
  },
  {
    id: "tournaments",
    label: "Torneos",
    path: "/tournaments",
  },
];
